module.exports = __webpack_public_path__ + "img/prize-03.01666122.png";